/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import MegaMenuLanguages from './MegaMenuLanguages';
import MegaMenuColumnItem from './MegaMenuColumnItem';
import BlurOverlay from '../../../../components/react/BlurOverlay.tsx';
import MegaMenuSearch from './MegaMenuSearch.tsx';
import { disableBodyScroll } from '../../redesign/util/bodyScroll.ts';

const MegaMenuDesktop = ({ megaMenu }) => {
  const [openedId, setOpenedId] = useState(null);

  if (!megaMenu) {
    return null;
  }

  const handleClick = (evt, id) => {
    if (openedId === id || id === null) {
      setOpenedId(null);
      disableBodyScroll(false);
      return;
    }
    disableBodyScroll(true);
    setOpenedId(id);
  };

  return (
    <div
      className={`mega-menu__nav-bar-container mega-menu--desktop ${
        openedId != null ? 'mega-menu__nav-bar-container--open' : ''
      }`}
    >
      <div className="mega-menu__nav-bar redesign__margin-container">
        <div className="mega-menu__nav-bar-logo">
          <a href="/">
            <img
              src={megaMenu.siteLogo?.expandedValue?.url}
              alt={
                megaMenu.siteLogo?.expandedValue?.altText?.value ||
                megaMenu.siteLogo?.name
              }
              width={180}
            />
          </a>
        </div>
        <div className="mega-menu__nav-bar-items">
          {megaMenu?.topNavigation?.expandedValue?.map((section, index) => (
            <>
              {section?.url?.value ? (
                <a
                  key={`nav-${index}-${section?.title?.value}`}
                  href={section.url.value}
                  className={`mega-menu__nav-bar-title ${
                    index === openedId ? 'mega-menu__nav-bar-title--open' : ''
                  }`}
                >
                  {section.title.value}
                </a>
              ) : (
                <button
                  key={`nav-${index}-${section?.title?.value}`}
                  onClick={e => handleClick(e, index)}
                  className={`mega-menu__nav-bar-title ${
                    index === openedId ? 'mega-menu__nav-bar-title--open' : ''
                  }`}
                >
                  {section.title.value}
                </button>
              )}
            </>
          ))}
          <button
            onClick={e =>
              handleClick(e, openedId === 'search' ? null : 'search')
            }
          >
            <svg role="presentation" className="mega-menu__nav-bar-search">
              <use
                xlinkHref={openedId === 'search' ? '#close' : '#search-icon'}
              />
            </svg>
          </button>
          <MegaMenuLanguages
            languagesExpandedValue={megaMenu.languagesArea?.expandedValue}
          />
        </div>
      </div>
      <div>
        {megaMenu?.topNavigation?.expandedValue?.map((section, index) => (
          <div
            className={`mega-menu__content ${
              !section?.url?.value && index === openedId
                ? 'mega-menu__content--open'
                : ''
            } ${openedId !== null ? 'mega-menu__content--any-open' : ''}`}
            key={`content-${index}-${section?.title?.value}`}
          >
            <div className="mega-menu__content-items-container">
              <div className="redesign__margin-container">
                <div className="mega-menu__content-items">
                  <div className="mega-menu__content-column">
                    {section.megaMenuColumn1?.expandedValue?.map(
                      (block, innerIndex) => (
                        <MegaMenuColumnItem
                          key={`${innerIndex}-${block?.name}`}
                          item={block}
                        />
                      )
                    )}
                  </div>
                  <div className="mega-menu__content-column">
                    {section.megaMenuColumn2?.expandedValue?.map(
                      (block, innerIndex) => (
                        <MegaMenuColumnItem
                          key={`${innerIndex}-${block?.name}`}
                          item={block}
                        />
                      )
                    )}
                  </div>
                  <div className="mega-menu__content-column">
                    {section.megaMenuColumn3?.expandedValue?.map(
                      (block, innerIndex) => (
                        <MegaMenuColumnItem
                          key={`${innerIndex}-${block?.name}`}
                          item={block}
                        />
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
        <div
          className={`mega-menu__content ${
            openedId === 'search' ? 'mega-menu__content--open' : ''
          } ${openedId !== null ? 'mega-menu__content--any-open' : ''}`}
        >
          <div className="mega-menu__content-items-container">
            <div className="redesign__margin-container">
              <div className="mega-menu__content-search">
                <MegaMenuSearch
                  isSearchOpen={openedId === 'search'}
                  searchPageUrl={megaMenu.searchPage?.value?.url}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {createPortal(
        <BlurOverlay
          visible={openedId !== null}
          onClick={e => handleClick(e, null)}
        />,
        document.body
      )}
    </div>
  );
};

export default MegaMenuDesktop;
